import SubEvents from '@gameday/common/components/form/Pages/SubEvents'
import { useState } from 'react'
import styled from 'styled-components'

import { getProductsTotalQuantityPerSession } from '../Products/component'

const StyledSubEvents = styled.div`
  --custom-primary-color: ${props => props.formSettings.textLinkColour};
`

const SubEventsComponent = ({
  registrations,
  memberProducts,
  currentRegistration,
  timezones,
  next,
  formType,
  feeConfigurations,
  paymentGateway,
  formSettings,
  subEvents,
  urlParams,
  setValue,
  validateSession,
  sessionId,
  products,
  productGroups,
  team,
  isTeamEvent,
  teamFormType,
  ...rest
}) => {
  const [formError, setFormError] = useState(undefined)
  const prods = isTeamEvent && teamFormType === 'Register A Team' ? team?.products : products
  const prodGroups = isTeamEvent && teamFormType === 'Register A Team' ? team?.productGroups : productGroups
  return (
    <StyledSubEvents className="subEvents-page" formSettings={formSettings}>
      <SubEvents
        subEvents={subEvents}
        mainProducts={prods.filter(p => !p.isForSubEvent)}
        productGroups={prodGroups}
        formData={{
          birthdate: currentRegistration?.birthdate,
          gender: currentRegistration?.gender,
          memberTypes: currentRegistration?.memberTypes,
          newProducts: currentRegistration?.newProducts,
          timezones,
        }}
        paidProducts={currentRegistration.products || []}
        // eslint-disable-next-line consistent-return
        onSelected={values => {
          const allSessionProds = { ...values, ...currentRegistration?.newProducts }
          // eslint-disable-next-line no-shadow
          const products = Object.keys(allSessionProds).reduce((a, k) => {
            const purchase = allSessionProds[k] || {}
            if (!purchase.checked) {
              return a
            }
            a.push({
              id: k,
              quantity: Number(purchase.quantity),
              formProductId: Number(purchase.formProductId),
              attributeValue: purchase.attributeValue,
            })
            return a
          }, [])

          const session = {
            source: 'Products',
            products,
          }

          // eslint-disable-next-line consistent-return
          const validateCallback = response => {
            if (response.success) {
              setValue({
                newSubEventProducts: values,
              })
              return next()
            }
            setFormError(response.message)
          }

          if (sessionId) {
            return validateSession(
              {
                ...session,
                products: getProductsTotalQuantityPerSession(session, registrations, currentRegistration),
              },
              validateCallback
            )
          }
        }}
        formType={formType}
        initialValues={currentRegistration?.newSubEventProducts}
        next={() => {}}
        formError={formError}
        feeConfigurations={feeConfigurations}
        paymentGateway={paymentGateway}
        isTeamEvent={isTeamEvent}
        teamFormType={teamFormType}
        {...rest}
      />
    </StyledSubEvents>
  )
}

export default SubEventsComponent
